import modalConstants from '../constants/modals';
import omit from 'lodash/omit';

const initialState = {
  modalType: null,
  modalProps: {},
  isOpen: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case modalConstants.OPEN_MODAL:
      return {
        modalProps: action.modalProps,
        modalType: action.modalType,
        isOpen: true,
        type: action.type,
      };

    case modalConstants.CLOSE_MODAL:
      return {
        ...state,
        isOpen: false,
        type: action.type,
      };
    case modalConstants.RESET_SUCCESS_RECOVERY_TEXT:
      return {
        ...state,
        modalProps: {
          ...omit(state.modalProps, 'shouldOpenEmailFormAfterRecovery'),

        },
      };
    default:
      return state;
  }
};
